import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../components/style.css"
import QRCode from 'qrcode.react';
require("moment/locale/th");

const ModalQRCodeUser = ({ af_id, person_id, full_name }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // let result = null;

    
    return (
        <>
            <div className="col-12 text-center d-flex align-items-center justify-content-center"style={{fontSize:"9px"}}>
                <div className="col-12" onClick={handleShow}>
                    <QRCode value={af_id != null ? af_id : person_id} size={40} />
                    <p  style={{fontSize:"9px"}}>คลิกรูปเพื่อซูม</p>
                </div>
            </div>
            
            <Modal
                show={show}
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-center"
                backdrop="static"
                centered
                keyboard={true}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="px-3 pt-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2 mb-2">
                                        <div className="col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "20px" }}>QR Code</div>
                                            <div className="fw-bold" style={{ fontSize: "20px" }}>{full_name}</div>                                           
                                        </div>
                                        <hr></hr>
                                    </div>

                                    <form className="row ">
                                        <div className="col-md-12 text-center" style={{ backgroundColor: "#FFFFFF" }} >
                                        <QRCode value={af_id != null ? af_id : person_id} size={220} />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
                        <Button variant="primary" style={{backgroundColor:"rgb(2, 117, 216,0.80)",border:"none"}} onClick={handleClose}>
                            ตกลง
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalQRCodeUser